var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResourcesOn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 56,
    viewBox: "0 0 55 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55.8533,
    rx: 27.5,
    fill: "#E0F0DB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6567 15.1353L24.4996 15.9333L23.8984 18.8533C22.9372 19.2204 22.0656 19.7408 21.278 20.3581L18.3397 19.3756L17.5503 19.1309L17.1409 19.8358L15.1181 23.2178L14.7087 23.9227L15.3081 24.4468L17.5813 26.3807C17.4991 26.8865 17.3931 27.3868 17.3931 27.9183C17.3931 28.4497 17.4991 28.9501 17.5813 29.4559L15.3081 31.3898L14.7087 31.9139L15.1181 32.6188L17.1409 36.0008L17.5503 36.7075L18.3397 36.461L21.278 35.4785C22.0656 36.0958 22.9372 36.6162 23.8984 36.9832L24.4996 39.9032L24.6567 40.7013H30.3416L30.5006 39.9032L31.0999 36.9832C32.0611 36.6162 32.9327 36.0958 33.7203 35.4785L36.6587 36.461L37.4481 36.7075L37.8592 36.0008L39.8803 32.6188L40.2914 31.9139L39.6902 31.3898L37.417 29.4559C37.5011 28.9501 37.6052 28.4497 37.6052 27.9183C37.6052 27.3868 37.5011 26.8865 37.417 26.3807L39.6902 24.4468L40.2914 23.9227L39.8803 23.2178L37.8592 19.8358L37.4481 19.1309L36.6587 19.3756L33.7203 20.3581C32.9327 19.7408 32.0611 19.2204 31.0999 18.8533L30.5006 15.9333L30.3416 15.1353H24.6567Z",
    stroke: "black",
    strokeWidth: 1.82733,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1541 27.9183C31.1541 29.9343 29.5168 31.5706 27.4994 31.5706C25.482 31.5706 23.8447 29.9343 23.8447 27.9183C23.8447 25.9022 25.482 24.266 27.4994 24.266C29.5168 24.266 31.1541 25.9022 31.1541 27.9183Z",
    stroke: "black",
    strokeWidth: 1.82733,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourcesOn);
export default __webpack_public_path__ + "static/media/resources_on.75cb68b7dab45fda769dfe857c897b9f.svg";
export { ForwardRef as ReactComponent };